import React, { useState } from 'react'
import { Row, Col, Card, Form, Button } from 'react-bootstrap'
import PerfectScrollbar from 'react-perfect-scrollbar'

import DatePicker from '../../../../../components/DatePicker/DatePickerCustom'
import HistoryItem from './HistoryItem'

const DocumentInfo = ({ invoice, handleChange }) => {
  const [isOpen, setIsOpen] = useState(false)

  const queView = 'q-view'
  const queViewActive = 'q-view active'

  const handleClose = () => {
    setIsOpen(false)
  }
  return (
    <>
      <fieldset class="scheduler-border">
        <legend class="scheduler-border font-medium">ข้อมูลเอกสาร</legend>

        <Row>
          <Col md="4">
            <Form.Group controlId="doc">
              <Form.Label>เอกสาร</Form.Label>
              <Form inline>
                <Form.Group>
                  <Form.Control type="text" />
                  <Button
                    className="btn-icon mx-1"
                    variant="primary"
                    onClick={() => setIsOpen(true)}
                  >
                    <i className="feather icon-rotate-cw mx-1" />
                  </Button>
                </Form.Group>
              </Form>
            </Form.Group>
          </Col>
          <Col md="4">
            <Form.Group controlId="doc">
              <Form.Label>เล่ม</Form.Label>
              <Form inline>
                <Form.Group>
                  <Form.Control
                    type="text"
                    value={invoice?.bookNumber}
                    readOnly
                  />
                  <Button className="btn-icon mx-1" variant="primary">
                    <i className="feather icon-edit-2 mx-1" />
                  </Button>
                </Form.Group>
              </Form>
            </Form.Group>
          </Col>
          <Col md="4">
            <Form.Group controlId="doc">
              <Form.Label>เลข</Form.Label>
              <Form inline>
                <Form.Group>
                  <Form.Control
                    type="text"
                    value={invoice?.invoiceNumber}
                    readOnly
                  />
                  <Button className="btn-icon mx-1" variant="primary">
                    <i className="feather icon-edit-2 mx-1" />
                  </Button>
                </Form.Group>
              </Form>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <Form.Group controlId="name">
              <Form.Group>
                <Form.Label>ออกในนาม</Form.Label>
                <Form.Control
                  type="text"
                  value={invoice?.bllTo?.fullName}
                  readOnly
                />
              </Form.Group>
            </Form.Group>
          </Col>
          <Col md="4">
            <Form.Group controlId="date">
              <Form.Group>
                <Form.Label>วันที่</Form.Label>
                <DatePicker
                  name="date"
                  value={invoice?.issuedDate}
                  readOnly
                  className={`form-control`}
                />
              </Form.Group>
            </Form.Group>
          </Col>
          <Col md="4">
            <Form.Group controlId="name">
              <Form.Group>
                <Form.Label>เลขที่ผู้เสียภาษี</Form.Label>
                <Form.Control
                  type="text"
                  value={invoice?.bllTo?.TaxpayerIdentificationNumber}
                  onChange={(e) =>
                    handleChange('TaxpayerIdentificationNumber', e.target.value)
                  }
                />
              </Form.Group>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <Form.Group controlId="address">
              <Form.Group>
                <Form.Label>ที่อยู่</Form.Label>
                <Form.Control
                  as="textarea"
                  type="text"
                  name="address"
                  rows={5}
                  value={invoice?.bllTo?.address}
                  readOnly
                />
              </Form.Group>
            </Form.Group>
          </Col>
          <Col md="4">
            <Form.Group controlId="name">
              <Form.Group>
                <Form.Label>เบอร์โทร</Form.Label>
                <Form.Control
                  type="text"
                  value={invoice?.bllTo?.phoneNumber}
                  onChange={(e) => handleChange('phoneNumber', e.target.value)}
                />
              </Form.Group>
            </Form.Group>
            <Form.Group controlId="name">
              <Form.Group>
                <Form.Label>วันที่ชำระ</Form.Label>
                <DatePicker
                  name="paymentDate"
                  value={invoice?.paymentDate}
                  readOnly
                  className={`form-control`}
                />
              </Form.Group>
            </Form.Group>
          </Col>
          <Col md="4">
            <Form.Group controlId="name">
              <Form.Group>
                <Form.Label>สาขา</Form.Label>
                <Form.Control
                  type="text"
                  value={invoice?.bllTo?.branchOffice}
                  onChange={(e) => handleChange('branchOffice', e.target.value)}
                />
              </Form.Group>
            </Form.Group>
            <Form.Group controlId="name">
              <Form.Group>
                <Form.Label>ผู้จัดทำ</Form.Label>
                <Form.Control type="text" readOnly />
              </Form.Group>
            </Form.Group>
          </Col>
        </Row>
      </fieldset>

      <div className={isOpen ? queViewActive : queView}>
        <div className="overlay" onClick={() => handleClose()} />
        <div className="content">
          <PerfectScrollbar>
            <Card.Body>
              <div className="border-bottom pb-3 pt-3">
                <div className="row">
                  <div className="col-md-7">
                    <h4 className="list-inline-item mb-0">
                      <i className="fas fa-history mx-3" />
                      ประวัติเอกสาร
                    </h4>
                  </div>
                </div>
              </div>
              <Row>
                <Col sm="12">
                  <HistoryItem />
                </Col>
              </Row>
            </Card.Body>
          </PerfectScrollbar>
        </div>
      </div>
    </>
  )
}

export default DocumentInfo
